<section>
  <app-ice-back-button
    testId="change-subscription-back-link"
    (click)="finishedSelection.emit()"
    (keydown.enter)="finishedSelection.emit()"
  />
  @if (product.isLoadingSubscriptionOfferings) {
    <app-spinner />
  } @else {
    <div class="offerings">
      @if (hasChangedServices) {
        <app-ice-alert type="info" [iconName]="IconNames.ice_info">
          <div heading>Tilbakestilling av tilleggstjenester</div>
          <div>Dine endringer av tilleggstjenester er blitt tilbakestillt ved endring av abonnement.</div>
        </app-ice-alert>
      }
      <h4>Endre abonnement</h4>

      @if (displayIceJuniorCostControlWarning) {
        <app-ice-alert class="icejunior-cost-info" iconWidth="2rem" type="info" [iconName]="IconNames.ice_info">
          <div>
            Med {{ product.offering.name }} kan barnet ringe til og fra utlandet, som kan medføre ekstra kostnader. Kunden
            kan legge inn sperre for dette i ice-appen eller på Min Side.
          </div>
        </app-ice-alert>
      }

      <form [formGroup]="form">
        <app-order-builder-step
          [allowedOfferings]="allowedOfferings"
          [assignedSubscription]="product.assignedSubscription"
          [product]="product"
          (productChanged)="onProductChange($event)"
          (sponsorSelected)="onSponsorSelected($event)"
          (sponsorTypeSelected)="onSponsorTypeSelected($event)"
        />
      </form>
    </div>
  }
</section>
